import ccbillService from '../services/ccbillService';
import { createOrGetMatrixRoom } from './matrixAction';
import { TRANSACTION_TYPE } from '../constants/common';

/**
 * Get OAuth token for CCBill widget (without dispatch)
 * @returns {Promise<Object>} Token result
 */
export const getToken = async () => {
  try {
    const response = await ccbillService.getToken();
    if (response.success) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: response.message };
    }
  } catch (error) {
    return { success: false, error: error.message || 'An unexpected error occurred' };
  }
};

/**
 * Charge using existing payment token action (without dispatch)
 * @param {Object} chargePayload - Charge payload containing paymentTokenId, clientSubacc, currencyCode, initialPrice, initialPeriod, passThroughInfo, and optionally recurringPrice, recurringPeriod, numRebills
 * @returns {Promise<Object>} Charge result
 */
export const charge = async (chargePayload) => {
  try {
    const response = await ccbillService.charge(chargePayload);
    
    if (response.success) {
      try {
        const type = chargePayload.passThroughInfo.find(f => f.name === 'c_payment_type')?.value;
        if (type === TRANSACTION_TYPE.SUBSCRIPTION) {
          const creatorId = chargePayload.passThroughInfo.find(f => f.name === 'c_creator_id')?.value;
          if (creatorId) {
            await createOrGetMatrixRoom(creatorId);
          }
        } 
      } catch (_) {}
      
      return { success: true, data: response.data };
    } else {
      return { success: false, error: response.message, status: response.status };
    }
  } catch (error) {
    const status = error?.status || error?.response?.status || 0;
    const rawMessage = error?.message || 'An unexpected error occurred';
    const errorMessage =
      status === 504
        ? 'Payment timed out. Please wait a moment and check your Transactions before retrying.'
        : rawMessage;

    return {
      success: false,
      error: errorMessage,
      status,
    };
  }
};

/**
 * Call CCBill webhook for free trial subscription action (without dispatch)
 * @param {Object} webhookPayload - Webhook payload containing queryParams and body
 * @returns {Promise<Object>} Webhook result
 */
export const callWebhook = async (webhookPayload) => {
  try {
    const response = await ccbillService.callWebhook(webhookPayload);
    
    if (response.success) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: response.message };
    }
  } catch (error) {
    return { success: false, error: error.message || 'An unexpected error occurred' };
  }
};

